import {
  FETCH_INITIAL_DATA_FOR_ADMIN_TAX_ENTRY_MODAL,
  FETCH_INITIAL_DATA_FOR_ADMIN_TAX_ENTRY_MODAL_SUCCESS,
  FETCH_INITIAL_DATA_FOR_ADMIN_TAX_ENTRY_MODAL_FAILURE,
} from './types';
import { derivedDataForImportSelector } from './selectors';
import { mapTypeAndActivityDescriptions } from './utils';
import {
  fetchTaxEntryType as fetchTaxEntryTypeApi,
  fetchTaxEntryActivity as fetchTaxEntryActivityApi,
  fetchTaxEntryView as fetchTaxEntryViewApi,
} from '../api';

import { FIELD_MAPPINGS, MIN_COLUMNS_NUMBER, MAX_COLUMNS_NUMBER } from '../xlsxImport/constants';
import columnHeaders from '../xlsxImport/columnHeaders';

import { fetchingError } from '../../../shared/store/actions';
import Config from '../../../config';
import agGridConfig from '../../../agGridConfig';
import { errorNotification } from '../../../shared/store/notificationActions';

import getActions from '../../shared/store/actionsFactory';
import { adminPageNames, adminPageTitles } from '../../shared/adminPageNames';
import getApi from '../../shared/apiFactory';

export const fetchInitialDataForTaxEntryModal = () => async dispatch => {
  dispatch({
    type: FETCH_INITIAL_DATA_FOR_ADMIN_TAX_ENTRY_MODAL,
  });

  try {
    const taxEntryTypeResponse = await fetchTaxEntryTypeApi();
    const taxEntryActivityResponse = await fetchTaxEntryActivityApi();
    const taxEntryViewResponse = await fetchTaxEntryViewApi();

    return dispatch({
      type: FETCH_INITIAL_DATA_FOR_ADMIN_TAX_ENTRY_MODAL_SUCCESS,
      taxEntryTypeValues: taxEntryTypeResponse,
      taxEntryActivityValues: taxEntryActivityResponse,
      taxEntryViewValues: taxEntryViewResponse,
    });
  } catch (error) {
    if (error.isFetchingError) {
      dispatch(fetchingError());
      dispatch(errorNotification(error.message));
      dispatch({ type: FETCH_INITIAL_DATA_FOR_ADMIN_TAX_ENTRY_MODAL_FAILURE });
      return;
    }
    throw error;
  }
};

export const showDeleteErrorTaxEntryAlert = message => errorNotification(
  message,
  {
    timeOut: 0,
    showCloseButton: true,
    removeOnHover: false,
  }
);

export const sharedActions = getActions(adminPageNames.ADMIN_TAX_ENTRY_SETTINGS, {
  pageTitle: adminPageTitles.ADMIN_TAX_ENTRY_SETTINGS,
  api: getApi({
    pageTitle: adminPageTitles.ADMIN_TAX_ENTRY_SETTINGS,
    endpoints: {
      FETCH: Config.endpoints.FETCH_ADMIN_TAX_ENTRIES,
      INSERT: Config.endpoints.INSERT_ADMIN_TAX_ENTRY,
      UPDATE: Config.endpoints.UPDATE_ADMIN_TAX_ENTRY,
      DELETE: Config.endpoints.DELETE_ADMIN_TAX_ENTRY,
      VALIDATE: Config.endpoints.VALIDATE_ADMIN_TAX_ENTRIES,
      IMPORT: Config.endpoints.IMPORT_ADMIN_TAX_ENTRIES,
    },
  }),
  sortingField: 'slAccount',
  agGridConfig: agGridConfig.adminTaxEntries,
  postProcessors: {
    extend: mapTypeAndActivityDescriptions,
  },
  excel: {
    sheetName: 'BSM Tax Entry',
    lastColumnLetter: 'G',
    columnHeaders,
    fieldMappings: FIELD_MAPPINGS,
    minColumnsNumber: MIN_COLUMNS_NUMBER,
    maxColumnsNumber: MAX_COLUMNS_NUMBER,

    fetchDerivedData: fetchInitialDataForTaxEntryModal,
    derivedDataSelector: derivedDataForImportSelector,
  },
});

export const fetchInitialDataForTaxEntries = period => async dispatch => {
  dispatch(sharedActions.fetchEntities(period));
};

